import { CheckboxIconTheme, styles, variants } from '../CheckboxIconStyles.css';
import { baseTheme } from './CheckboxIconBaseTheme.css';
import { multiVariantStyles } from './CheckboxIconVariants.css';

/*******************
 * Component Theme
 *******************/

const CheckboxIconRedwoodTheme: CheckboxIconTheme = {
  baseTheme,
  multiVariantStyles,
  variants,
  styles
};

/*******************
 * Exports
 *******************/

export { CheckboxIconRedwoodTheme };
